import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, Select, Divider } from 'antd';
import { useMutation, useQuery } from 'react-query';
import { useFormik } from 'formik';
import * as yup from 'yup';
import rootApi from '@utils/baseAPI/WrapperApi';
import get from 'lodash/get';
import { showSuccess, showError } from '@components/notification';
import { useNavigate } from 'react-router-dom';
import { apiUpdateRoleUserOperator } from '@services/ManageUserOperator/UserOperatorServices';
import {
  apiGetAllRoles,
  apiAssignRolesToUser,
  apiGetUserRoles
} from '@services/ManageRoles/RoleServices';

const { Option } = Select;

const DialogsChangeRole = (props) => {
  const { userInfo, open, setOpen, refetch } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (open && userInfo) {
      fetchRolesAndUserRoles();
    }
  }, [open, userInfo]);

  const fetchRolesAndUserRoles = async () => {
    try {
      const [rolesResponse, userRolesResponse] = await Promise.all([
        apiGetAllRoles(),
        apiGetUserRoles(userInfo.id)
      ]);

      const allRoles = rolesResponse?.data?.data || [];
      const currentRoles = userRolesResponse?.data?.data || [];

      setRoles(allRoles);
      setUserRoles(currentRoles.map((role) => role.id));
    } catch (error) {
      console.error('Error fetching roles:', error);
      showError('Có lỗi xảy ra khi tải thông tin vai trò');
    }
  };

  const handleClose = () => {
    refetch && refetch();
    setOpen(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      role_ids: userRoles
    },
    validationSchema: yup.object({
      role_ids: yup
        .array()
        .min(1, 'Vui lòng chọn ít nhất một vai trò')
        .required()
        .label('Vai trò người dùng')
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        await apiAssignRolesToUser({
          user_id: userInfo?.id,
          role_ids: values.role_ids
        });
        handleClose();
        refetch && refetch();
        !refetch && navigate(`/admin/user`);
        showSuccess({ message: 'Cập nhật vai trò người dùng thành công' });
        formik.resetForm();
      } catch (err) {
        console.log('err:::', err);
        showError(err);
      } finally {
        setIsLoading(false);
      }
    }
  });

  // Update formik values when userRoles changes
  useEffect(() => {
    formik.setFieldValue('role_ids', userRoles);
  }, [userRoles]);

  return (
    <div>
      <Modal
        title="Cập nhật người dùng"
        visible={open}
        onCancel={handleClose}
        footer={[
          <Button key="back" style={{ height: '36px' }} onClick={handleClose}>
            Hủy
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoading}
            style={{ backgroundColor: '#10b981', color: '#FFFF', height: '36px' }}
            onClick={formik.handleSubmit}>
            Cập nhật
          </Button>
        ]}>
        <Form layout="vertical">
          <Form.Item label="Tên đăng nhập" style={{ marginBottom: 10 }}>
            <Input value={userInfo?.username} style={{ height: '36px' }} disabled />
          </Form.Item>
          <Form.Item label="Số điện thoại" style={{ marginBottom: 10 }}>
            <Input value={userInfo?.phone_number} style={{ height: '36px' }} disabled />
          </Form.Item>
          <Form.Item label="Email" style={{ marginBottom: 10 }}>
            <Input value={userInfo?.email} style={{ height: '36px' }} disabled />
          </Form.Item>
          <Form.Item
            label="Vai trò người dùng"
            validateStatus={formik.errors.role_ids ? 'error' : ''}
            help={formik.errors.role_ids}
            style={{ marginBottom: 10 }}>
            <Select
              mode="multiple"
              name="role_ids"
              placeholder="Chọn vai trò cho người dùng"
              value={formik.values.role_ids}
              onChange={(value) => formik.setFieldValue('role_ids', value)}>
              {roles.map((role) => (
                <Option key={role.id} value={role.id}>
                  {role.name} - {role.descriptions || 'Không có mô tả'}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default DialogsChangeRole;
